// A form belongs to the account/company with which this page was opened.
// Another tab must not silently redirect its requests to a different company.
function currentContext() {
  let identity = "";
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const claims = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
      identity = JSON.stringify([claims.sub, claims.tenant_db_url, claims.user_name]);
    } catch {
      identity = token;
    }
  }
  return JSON.stringify([identity, localStorage.getItem("active_tenant") || ""]);
}

let pageContext = currentContext();

export function resetRequestContext() {
  pageContext = currentContext();
}

export function checkRequestContext(expected = pageContext) {
  if (expected !== pageContext || expected !== currentContext()) {
    const error = new Error("Firma sau utilizatorul s-a schimbat în altă filă. Reîncărcați pagina înainte de a continua; formularul vechi nu a fost trimis către noua firmă.");
    error.code = "ERP_CONTEXT_CHANGED";
    throw error;
  }
  return expected;
}

export function isAuthenticationRequest(config) {
  return /(?:^|\/)auth\/(?:login|register|refresh)(?:\?|$)/.test(config.url || "");
}
